import React from "react";
import { SectionHeading } from "../SectionHeading";
import { SectionCta } from "../SectionCta";
import { extraConcepts, monitorParameters } from "../../data/content";
export function ProblemSection() {
  return <section className="bg-canvas px-4 py-16 sm:py-24" data-id="element-281" data-mp="8jsakzbj6ezr">
      <div className="mx-auto max-w-5xl" data-id="element-282" data-mp="djwrgqgcpbqi">
        <SectionHeading title={<>
              From confusing monitoring numbers to a <span className="text-brand" data-id="element-284" data-mp="3vogkhb3cltkt">more structured understanding</span> of hemodynamics
            </>} intro="As a critical care nursing professional, you know that hemodynamic monitoring involves much more than recognizing numbers on a bedside monitor." data-id="element-283" data-mp="div4popz30sy" />

        <div className="mx-auto mt-10 max-w-3xl rounded-3xl bg-navy p-4 shadow-xl sm:p-6" data-id="element-285" data-mp="3qrho0lw7pajg">
          <p className="px-1 text-sm font-semibold text-brand-sky" data-id="element-286" data-mp="1jzpb7ksqenct">You may already recognize terms such as:</p>
          <div className="mt-4 grid grid-cols-2 gap-2.5 sm:grid-cols-3 sm:gap-3" data-id="element-287" data-mp="1oy0k9tb7cttz">
            {monitorParameters.map(p => <div key={p.abbr} className="rounded-xl bg-navy-800 p-3.5 ring-1 ring-white/10 sm:p-4" data-id="element-288" data-mp="1nm05upe0z6ey">
                <p className="font-mono text-3xl font-bold text-monitor sm:text-4xl" data-id="element-289" data-mp="1imnhu1bf3tas">{p.abbr}</p>
                <p className="mt-1 text-sm font-medium leading-snug text-white" data-id="element-290" data-mp="1wfd7qgu2hid6">{p.label}</p>
              </div>)}
          </div>
          <div className="mt-3 flex flex-wrap gap-2" data-id="element-291" data-mp="14ogrd68ssvl5">
            {extraConcepts.map(c => <span key={c} className="rounded-full bg-navy-700 px-3.5 py-1.5 text-sm font-semibold text-white" data-id="element-292" data-mp="zq5kn4dsv175">
                {c}
              </span>)}
          </div>
        </div>

        <div className="mx-auto mt-10 max-w-3xl space-y-5 text-center text-lg leading-relaxed text-muted" data-id="element-293" data-mp="18qtvjq7wclft">
          <p data-id="element-294" data-mp="2p4aky5jf8oz2">
            Understanding cardiovascular physiology means learning how different parameters relate to one another, what they represent,
            and why their limitations matter.
          </p>
          <p className="text-2xl font-extrabold leading-snug text-navy sm:text-3xl" data-id="element-295" data-mp="1ht469vh43g4p">
            But recognizing a parameter is not the same as understanding its physiological context.
          </p>
          <p data-id="element-296" data-mp="1qsrasq55121z">
            The Hemodynamic Monitoring Blueprint™ brings these concepts together in six organized volumes, supported by visual diagrams,
            comparison tables, worksheets, and simulated clinical cases.
          </p>
        </div>

        <SectionCta label="I want to understand the numbers" data-id="element-297" data-mp="yzqm8lexsu3v" />
      </div>
    </section>;
}